import { Action, handleActions } from 'redux-actions'
import { ChatChannelKind } from '../../../components/YumChatView/useChatChannel'
import type { ChannelMeta } from '../hooks/useChatChannelList'
import { setChatChannelMeta, setChatListFilter, setChatUnreadCount } from './ChatActions'

class State {
  // Kept in the store so the selection survives remounts when the route switches
  // between /chat and /chat/:channelKind/:channelId.
  chatListFilter: ChatChannelKind | null = null
  // Total unread chat messages across all channels, kept live by ChatSagas.
  unreadCount: number = 0
  // Per-channel Stream metadata (preview, timestamp, unread) by cid. Persisted with the rest
  // of the slice, so the chat list paints instantly (and offline) from the last known state
  // while a fresh enrichment runs in the background.
  channelMeta: Record<string, ChannelMeta> = {}
}

export const chat = handleActions<State, any>(
  {
    [String(setChatListFilter)]: (state: State, action: Action<ChatChannelKind | null>): State => ({
      ...state,
      chatListFilter: action.payload,
    }),
    [String(setChatUnreadCount)]: (state: State, action: Action<number>): State => ({
      ...state,
      unreadCount: action.payload,
    }),
    [String(setChatChannelMeta)]: (state: State, action: Action<Record<string, ChannelMeta>>): State => ({
      ...state,
      channelMeta: action.payload,
    }),
  },
  new State(),
)

export { State as ChatState }
